import { render, staticRenderFns } from "./Promotion_edit.vue?vue&type=template&id=f2544dd6&scoped=true&"
import script from "./Promotion_edit.vue?vue&type=script&lang=js&"
export * from "./Promotion_edit.vue?vue&type=script&lang=js&"
import style0 from "./Promotion_edit.vue?vue&type=style&index=0&id=f2544dd6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2544dd6",
  null
  
)

export default component.exports